import React from 'react';
import {
  flowRight,
  isNil,
  isObject
} from 'lodash';
import {
  ELSPropsFromToastService,
  ELSWithToastService
} from '@els/els-component-toast-react';
import { ELSIcon } from '@els/els-component-form-field-react';
import {
  ChatEntryDto,
} from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';
import { copyContentToClipboard } from '../../utilities/common.utilities';
import { BASE_TOAST_CONFIG } from '../../constants/toast.constants';

type AiChatAdminEntryModalPropsOnly = {
  entry: ChatEntryDto;
  handleClose: () => void;
}

type AiChatAdminEntryModalProps = AiChatAdminEntryModalPropsOnly & ELSPropsFromToastService
const AiChatAdminEntryModalComponent = (props: AiChatAdminEntryModalProps) => {
  const { toastService } = props;
  const renderKeyValue = (value) => {
    if (isNil(value)) {
      return '';
    }
    if (isObject(value)) {
      return JSON.stringify(value);
    }
    return value.toString();
  };

  const cerebusTraceId = `entry_${props.entry.id}`;

  return (
    <div>
      <div className="c-els-modal c-els-modal--full">
        <div className="c-els-modal__window u-els-width-1o1">
          <div className="c-naa-ai-chat-admin-entry-modal">

            <button
              type="button"
              className="c-els-modal__close"
              onClick={props.handleClose}
            >
              <ELSIcon name="close" size="1x" />
              <span className="u-els-hide-visually">Close this modal window</span>
            </button>

            <h2>Entry</h2>
            <div className="u-els-margin-top-1x u-els-margin-bottom-1x">
              <span className="u-els-font-family-bold u-els-margin-right-1o2">Cerebus trace:</span>
              <span className="u-els-margin-right-1o2">{cerebusTraceId}</span>
              <button
                type="button"
                className="c-els-button c-els-button--small c-els-button--secondary"
                onClick={() => {
                  copyContentToClipboard(cerebusTraceId);
                  toastService.openToast({
                    ...BASE_TOAST_CONFIG,
                    component: (<div>Successfully copied</div>),
                    type: ELSWithToastService.types.POSITIVE
                  });
                }}
              >
                Copy
              </button>
            </div>
            <div className="u-els-margin-top-1x u-els-margin-bottom-2x">
              <table>
                <tbody>
                  {
                    Object.keys(props.entry).map((key) => {
                      return (
                        <tr key={key}>
                          <td>{key}:</td>
                          <td className="u-els-padding-left">{renderKeyValue(props.entry[key])}</td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const enhance = flowRight(
  ELSWithToastService,
);

const AiChatAdminEntryModal: React.FC<AiChatAdminEntryModalPropsOnly> = enhance(AiChatAdminEntryModalComponent);
export default AiChatAdminEntryModal;
